// @flow

import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { PDF_LICENSE_KEY } from '../../config'

type PDFProps = {
  url: string
}

const WebViewContainer = styled.div`
  height: 900px;
  padding-left: 10px;
  padding-right: 10px;

  @media only screen and (max-width: 700px) {
    height: 700px;
  }
`

const WebView = styled.div`
  width: 100%;
  height: 100%;
`

function NewPDF ({ url }: PDFProps) {
  const viewer = useRef(null)

  useEffect(() => {
    const loadWebViewer = async () => {
      const WebViewer = (await import('@pdftron/pdfjs-express-viewer')).default
      if (viewer.current) {
        WebViewer(
          {
            licenseKey: PDF_LICENSE_KEY,
            path: '/pdfjsexpress',
            initialDoc: url
          },
          viewer.current
        ).then((instance) => {
          const { UI } = instance
          UI.setTheme('dark')
          UI.disableElements([
            'pageTransitionHeader', 'layoutHeader', 'defaultPageTransitionButton',
            'continuousPageTransitionButton', 'singleLayoutButton', 'doubleLayoutButton', 'coverLayoutButton',
            'contextMenuPopup', 'viewControlsDivider1', 'viewControlsDivider2', 'downloadButton', 'printButton',
            'themeChangeButton', 'languageButton'
          ])
          if (window.innerWidth < 769) {
            UI.disableElements(['menuButton'])
          }
        })
      }
    }
    loadWebViewer()
  }, [url])

  return (
    <WebViewContainer>
      <WebView ref={viewer} />
    </WebViewContainer>
  )
}

export default NewPDF
